import * as Yup from 'yup';
import { StringSchema } from 'yup';
import { AxiosInstance } from 'axios';

type ValidationStringSchemaType = Record<string, StringSchema<Exclude<string | undefined, undefined | null>, object>>;

enum userValidationEnum {
  firstName = 'First name',
  lastName = 'Last name'
}

export const baseUserFieldValidation = (
  field: keyof typeof userValidationEnum,
  maxLength: number
): ValidationStringSchemaType => ({
  [`${field}`]: Yup.string()
    .max(maxLength, `${userValidationEnum[field]} must be less than ${maxLength} characters`)
    .required(`${userValidationEnum[field]} is required`)
});

export const baseUserValidationSchema = (authAxios: AxiosInstance, email: string = '') => ({
  ...baseUserFieldValidation('firstName', 60),
  ...baseUserFieldValidation('lastName', 60),
  email: Yup.string()
    .email('Email is invalid')
    .max(255, 'Email must be less than 255 characters')
    .required('Required')
    .test('checkEmailUnique', 'This email is already registered.', (value) => {
      if (value && value.length >= 4 && value !== email) {
        return authAxios
          .post<any>('/users/client-reps/validate-email', { email: value })
          .then(({ data }) => data.available);
      }
      return true;
    })
});
